<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>头像</title>
    <desc>Created with Sketch.</desc>
    <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="账户" transform="translate(0.000000, -2.000000)" fill="#CCD8E9">
        <path
          d="M12,2 C18.627417,2 24,7.372583 24,14 C24,20.627417 18.627417,26 12,26 C5.372583,26 0,20.627417 0,14 C0,7.372583 5.372583,2 12,2 Z M12.1104221,7 C10.0125783,7 8.3487712,8.70466321 8.3487712,10.7720207 C8.3487712,12.1502591 9.0721656,13.3471503 10.1572572,14 C8.27643175,14.5440415 6.79347323,15.7772021 6.10624855,17.4093264 C5.81689079,18.0621762 6.14241827,19.0414508 6.79347323,19.4404145 C8.38494092,20.4559585 10.2295966,21 12.1465918,21 C14.1359264,21 16.0529216,20.4196891 17.7167287,19.3316062 C18.3316139,18.8963731 18.6209717,17.9170984 18.3316139,17.2642487 C17.5720498,15.6321244 16.0529216,14.3989637 14.1359264,13.9274611 C15.1486786,13.238342 15.8359032,12.0777202 15.8359032,10.7720207 C15.8359032,8.70466321 14.1359264,7 12.1104221,7 Z"
          id="头像"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Avatar'
});
</script>
